window.onclick = function(event) {
    if (event.target.id == "customAlert")
    {
        document.getElementById("customAlert").style.display = "none";
    }
};

export function showCustomAlert(message) {
    document.getElementById("alertMessage").textContent = message;
    document.getElementById("customAlert").style.display = "block";
}
